export default __webpack_public_path__ + "static/media/rotate.5dacbfc1.gif";